import { isQuotingToolAvailable } from 'modules/common/permissions';
import { init } from 'modules/metrics/data/sagas';

export default [
  {
    exact: true,
    name: 'metrics',
    path: '/metrics',
    permissions: [isQuotingToolAvailable],
    saga: init,
  },
];
